import React, { useState, useRef, useEffect } from "react";
import { Select, MenuItem, Checkbox, ListItemText, FormControl } from "@mui/material";

function ReplaceQuestionChapterDropdown(props) {
  const [chapters, setChapters] = useState(props.chapterList);
  const [selectedChapter, setSelectedChapter] = useState("");
  const selectRef = useRef(null);
  const [dropdownWidth, setDropdownWidth] = useState(0);

  useEffect(() => {
    if (selectRef.current) {
      setDropdownWidth(selectRef.current.offsetWidth);
    }
  }, []);

  const handleChange = (event) => {
    setSelectedChapter(event.target.value);
    props.handleOnChange(event);
  };

  const selectFieldStyles = {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid",
      borderColor: "black",
      // Change the border color to your desired focus color
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#79747e", // Change the normal border color here
    },
    "& .MuiSelect-select.MuiSelect-select": {
      marginTop: "5px",
      marginLeft: "13px",
      color: "#474747", // Change the color of the selected option(s)
      fontSize: "18px",
      fontWeight: "399",
      fontFamily:
        'system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"', // Change the font size of the selected option(s)
    },
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <div >
      <FormControl
       // style={{ width: "100%", margin: "10px 10px 20px 0px" }}
       sx={selectFieldStyles}
       className="w-[100%] pb-[10px]"
      >
      <Select
        id="modules_option"
        name="chapter"
        value={selectedChapter}
        onChange={handleChange}
        displayEmpty
        inputRef={selectRef}
        renderValue={(selected) => selected || "Select topic"}
        style={{
          height: "50px",
          // width: "100%",
          // fontWeight: 100,
          // fontSize: 20,
          // color: "#7C7C7C",
          // paddingLeft: "16px"
        }}
        MenuProps={MenuProps}
        // MenuProps={{
        //   PaperProps: {
        //     style: {
        //       maxHeight: 300,
        //       width: dropdownWidth || 300,
        //     }
        //   },
        //   anchorOrigin: {
        //     vertical: "bottom",
        //     horizontal: "left"
        //   },
        //   transformOrigin: {
        //     vertical: "top",
        //     horizontal: "left"
        //   },
        //   getContentAnchorEl: null
        // }}
      >
        <MenuItem disabled value="">
          Select topic
        </MenuItem>
        {chapters.map((chapter) => (
          <MenuItem
            key={chapter.chapter_id}
            value={chapter.chapter_name}
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              width: "100%",
              display: "block"
            }}
          >
            {chapter.chapter_name}
          </MenuItem>
        ))}
      </Select>
      </FormControl>
    </div>
  );
}

export default ReplaceQuestionChapterDropdown;
